import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @description Abstract class for Freewheel global parameters
 */
export abstract class AbstractFWGlobalParams extends AbstractFreewheelClass {

	/**
	 * @description Internal store for global ad parameters
	 * @readonly
	 */
	protected readonly abstract adParams: object;

	protected constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'AbstractFWGlobalParams',
				...argument
			}
		);
	}

	/**
	 * @description Returns global parameters
	 * @returns {object}
	 */
	get adParameters(): object {
		return this.adParams;
	}
}